<template>
  <div class="login_page">
    <div class="left_img">
      <img src="@/assets/images/login/login_left.png" alt="">
    </div>
    <div class="right_form" v-if="!showRegister">
      <el-form ref="loginForm" :model="loginForm" class="login_form">
        <div class="mmc_title_with_line">用户登录</div>
        <el-form-item prop="userName" :rules="[{ required: true, message: '请输入用户名', trigger: 'blur' }]">
          <el-input placeholder="请输入用户名" v-model.trim="loginForm.userName">
            <img slot="prefix" src="@/assets/images/login/icon1.png"/>
          </el-input>
        </el-form-item>
        <el-form-item prop="userPwd" :rules="[{ required: true, message: '请输入密码', trigger: 'blur' }]">
          <el-input type="password" placeholder="请输入密码" v-model.trim="loginForm.userPwd" clear="password_input" @focus="inputPwd">
            <img slot="prefix" src="@/assets/images/login/icon2.png"/>
          </el-input>
        </el-form-item>
        <el-form-item prop="imgCode" class="has_no_margin" :rules="[{ required: true, message: '请输入图形验证码', trigger: 'blur' }]">
          <el-input type="text" placeholder="请输入图形验证码" v-model.trim="loginForm.imgCode" @keyup.enter.native="onSubmit" class="code_input">
            <img slot="prefix" src="@/assets/images/login/icon3.png"/>
            <canvas slot="append" id="canvas" width="85" height="34"  @click="getImgCode"></canvas>
          </el-input>
        </el-form-item>
        <el-form-item prop="savePwd">
          <el-checkbox v-model="savePwd">记住密码</el-checkbox>
        </el-form-item>
        <el-form-item>
          <el-button round type="primary" @click="onSubmit" class="login_btn" :loading="btnloading">确认</el-button>
        </el-form-item>
        <div class="bottom_tips">我还没有账号，<a @click="$router.push({path:'/login',query:{isR:true}})">立即注册</a></div>
      </el-form>
    </div>
    <div class="right_form" v-else>
      <el-form label-position="right" ref="registerForm" :model="registerForm" class="register_form" label-width="80px">
        <div class="mmc_title_with_line">用户注册</div>
        <el-form-item label="用户名" prop="userName" :rules="[{ required: true, message: '请输入用户名', trigger: 'blur' }]">
          <el-input v-model="registerForm.userName" placeholder="请输入用户名"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="userPwd" :rules="[{ required: true, message: '请输入密码', trigger: 'blur' }]">
          <el-input type="password" v-model="registerForm.userPwd" placeholder="请输入密码"></el-input>
        </el-form-item>
        <el-form-item label="重复密码" prop="userPwd2" :rules="[{ required: true, message: '请重复输入密码', trigger: 'blur' }]" :error="pwd2Error">
          <el-input type="password" v-model="registerForm.userPwd2" placeholder="请重复输入密码" @change="pwd2Error=''"></el-input>
        </el-form-item>
        <el-form-item label="邮箱地址" prop="userEmail" :rules="[
          { required: true, message: '请输入邮箱地址', trigger: 'blur' },
          { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }
        ]">
          <el-input type="email" v-model="registerForm.userEmail" placeholder="请输入邮箱地址"></el-input>
        </el-form-item>
        <el-form-item label="验证码" prop="imgCode" :rules="[{ required: true, message: '请输入图形验证码', trigger: 'blur' }]">
          <el-input v-model="registerForm.imgCode" placeholder="请输入图形验证码" class="code_input">
            <canvas slot="append" id="canvas2" width="85" height="34"  @click="getImgCode"></canvas>
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button round type="primary" @click="onSubmit" class="login_btn" :loading="btnloading">确认</el-button>
        </el-form-item>
        <div class="bottom_tips">我已有账号，<a @click="$router.push('/login')">马上登录</a></div>
      </el-form>
    </div>
  </div>
</template>

<script>
import imgCode from '@/assets/js/imgcode'
export default {
  data(){
    return{
      loginForm: {
        userName: "",
        userPwd: "",
        imgCode: ""
      },
      savePwd:false,
      imgCode:'',//获取到的验证码
      btnloading:false,
      showRegister:this.$route.query.isR,//注册
      registerForm:{
        userName:'',
        userPwd:'',
        userPwd2:'',
        userEmail:'',
        imgCode:''
      },
      pwd2Error:'',//重复输入密码的错误提示
      yizhuceList:localStorage.getItem('zhizhongUserList')?JSON.parse(localStorage.getItem('zhizhongUserList')):[]
    }
  },
  mounted(){
    imgCode.createdCodeImg(this.showRegister?'canvas2':'canvas')
  },
  methods:{
    getImgCode(e){
      imgCode.createdCodeImg(e.target.id);
    },
    inputPwd(){//记住密码自动匹配密码
      if(this.loginForm.userName){
        const user = this.yizhuceList.filter(item=>item.userName == this.loginForm.userName)
        if(user.length > 0){
          this.savePwd = user[0].savePwd
          if(this.savePwd){
            this.loginForm.userPwd = user[0].userPwd
          }
        }
      }
    },
    onSubmit(){
      this.pwd2Error = ''
      if(this.showRegister){
        //注册
        if(this.registerForm.userPwd2 !== this.registerForm.userPwd){
          this.pwd2Error = '两次输入的密码不一致'
          return false;
        }
        if(this.registerForm.imgCode.toUpperCase() !== sessionStorage.getItem('zhizhongCode')){
          this.$message.warning('验证码校验失败');
          imgCode.createdCodeImg(this.showRegister?'canvas2':'canvas')
          return false;
        }
        this.$refs['registerForm'].validate((valid) => {
          if (valid) {
            this.yizhuceList.push({
              userName:this.registerForm.userName,
              userPwd:this.registerForm.userPwd,
              userEmail:this.registerForm.userEmail,
              savePwd:false
            })
            localStorage.setItem('zhizhongUserList',JSON.stringify(this.yizhuceList))
            if(JSON.parse(localStorage.getItem('zhizhongUserList')).filter(item=>item.userName = this.registerForm.userName).length > 0 ){
              this.$message.success('注册成功！')
              this.$router.replace('/login')
            }
          }else{
            return false;
          }
        })
      }else{
        //登录
        if(this.loginForm.imgCode.toUpperCase() !== sessionStorage.getItem('zhizhongCode')){
          this.$message.warning('验证码校验失败');
          imgCode.createdCodeImg(this.showRegister?'canvas2':'canvas')
          return false;
        }
        if(this.yizhuceList.filter(item=>item.userName == this.loginForm.userName).length == 0){
          this.$message.warning('该用户不存在');
          return false;
        }
        const userIn = this.yizhuceList.filter(item=>item.userName == this.loginForm.userName)
        if( userIn.length > 0 && userIn[0].userPwd !== this.loginForm.userPwd){
          this.$message.warning('用户名或密码不匹配');
          return false;
        }
        this.$refs['loginForm'].validate((valid) => {
          if (valid) {
            this.yizhuceList.map(item=>{  //是否记住密码
              if(item.userName == this.loginForm.userName){
                return item.savePwd = this.savePwd
              }
            })
            localStorage.setItem('zhizhongUserList',JSON.stringify(this.yizhuceList))
            this.$store.commit('saveCurrentUser',this.loginForm.userName)
            this.$router.replace('/home')
          }else{
            return false;
          }
        })
      }
    }
  },
  watch:{
    '$route'(){
      const href = window.location.href
      const val = href.slice(href.indexOf('=')+1);
      this.showRegister = Boolean(href.indexOf('=')>0?val:false)
    }
  }
}
</script>

<style lang="less">
@bule_color:#0093DD;
.login_page{
  max-width: 1170px;
  margin: 0 auto;
  overflow: hidden;
  background-color: #fff;
  .left_img,.right_form{
    float: left;
    width: 50%;
  }
  .left_img{
    img{
      height: 100%;
      display: block;
    }
  }
  .right_form{
    .el-form-item.is-required{
      .el-form-item__label::before{
        display: none;
      }
    }
    .login_form{
      padding: 64px 0 0 70px;
      .el-form-item{
        margin-bottom: 25px;
      }
    }
    .register_form{
      padding: 28px 70px;
      .el-form-item{
        margin-bottom: 17px;
      }
    }
    min-height: 532px;
    box-sizing: border-box;
    .mmc_title_with_line{
      color: @bule_color;
    }
    .el-form{
      width: 322px;
      &.register_form{
        width: 400px;
      }
      .el-form-item {
        .el-form-item__label{
          font-size: 16px;
        }
        &.has_no_margin{
          margin-bottom: 0;
        }
        .login_btn {
          display: block;
          width: 100%;
          padding: 10px 20px;
        }
        .el-input{
          &.el-input--prefix .el-input__inner{
            padding-left: 49px;
          }
          .el-input__prefix{
            margin: 0 10px;
            img{
              width: 20px;
            }
          }
          &.password_input{
            .el-input__prefix{
              img{
                width: 22px;
              }
            }
          }
          &.code_input{
            .el-input__prefix{
              line-height: 35px;
              img{
                width:17.6px;
              }
            }
            .el-input-group__append{
              padding: 0;
              background-color: #fff;
              canvas{
                transform: translateY(2px);
              }
            }
          }
        }
        .el-checkbox__input.is-checked .el-checkbox__inner, 
        .el-checkbox__input.is-indeterminate .el-checkbox__inner,{
          background-color: @bule_color;
          border-color: @bule_color;
        }
        .el-checkbox__input.is-checked+.el-checkbox__label{
          color: #888;
        }
        .el-checkbox{
          margin-left: 10px;
          margin-top: 5px;
          margin-bottom: -5px;
          .el-checkbox__inner{
            border-radius: 50%;
            transform: scale(1.3);
          }
        }
        .el-button--primary{
          font-weight: 600;
          letter-spacing: 1em;
          font-size: 18px;
        }
      }
      .bottom_tips{
        font-size: 14px;
        text-align: center;
        a{
          color: @bule_color;
          text-decoration: none;
        }
      }
    }
  }
}
</style>
